<template>
  <el-row v-loading="loading" class="pond-feed-tab">
    <el-row type="flex" justify="space-between">
      <el-col :span="7">
        <er-date-picker
          size="small"
          :key="selectedPondDetails._id"
          v-model="dateRangeSelected"
          value-format="yyyy-MM-dd"
          :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
          type="daterange"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="initComponent"
        ></er-date-picker>
      </el-col>
      <el-col>
        <layout-toolbar class="second-label-container">
          <div class="total__feed__button">
            <div class="total__feed__button__label">{{ $t("total_feed") }}</div>
            <div class="highest__feed__button__value">
              {{ total_manual_feed | numberWithNDigitPrecision(1)
              }}{{
                getUserCountryName.toLowerCase() === "india" ? "kgs" : "kgs"
              }}
            </div>
          </div>
          <div class="highest__feed__button">
            <div class="highest__feed__button__label">
              {{ $t("Comn_highest_feed") }}
            </div>
            <div class="highest__feed__button__value">
              {{ highest_feed | numberWithNDigitPrecision(1)
              }}{{
                getUserCountryName.toLowerCase() === "india" ? "kgs" : "kgs"
              }}
            </div>
          </div>

          <div>
            <er-download-drop-down
              :download-types="['EXCEL', 'PDF']"
              @download-action="handleDownloadAction"
            ></er-download-drop-down>
          </div>
          <div>
            <er-button
              btnType="print"
              @click="handlePrintBtnClick"
              :showLabel="true"
              :showIcon="true"
            ></er-button>
          </div>
        </layout-toolbar>
      </el-col> </el-row
    >&nbsp;
    <el-row>
      <el-col>
        <er-card>
          <er-data-tables
            :tableData="data"
            uniqueId="pond-feed-tab"
            :merge="{ startColumnNumber: 1, endColumnNumber: 2 }"
            :columns="tableColumns"
            :action-column="false"
            type="white-header-table"
            size="mini"
            :key="$i18n.locale"
          >
            <template v-slot:doc="{ row }">{{ row.data.doc }}</template>
            <template v-slot:event_date="{ row }">{{
              $moment(row.data.date).format(
                $commonUtils.MOMENT_DATE_FORMAT_WITH_YEAR
              )
            }}</template>
            <template v-slot:feed_name="{ row }">{{
              row.data.feed_name
            }}</template>
            <template v-slot:feed_dispensed="{ row }">{{
              row.data.feed_dispensed | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:net_consumed="{ row }">{{
              row.data.net_consumed | numberWithNDigitPrecision(2)
            }}</template>
            <template v-slot:actions="{ row }">
              <el-row type="flex" justify="start" align="middle">
                <er-button
                  type="text"
                  size="mini"
                  btnType="edit"
                  :showLabel="true"
                  :showIcon="true"
                  :disabled="clickable"
                  @click="handleEditMFeedRecord(row.data)"
                ></er-button>
                <el-divider direction="vertical"></el-divider>
                <er-button
                  type="text"
                  size="mini"
                  btnType="delete"
                  :showLabel="true"
                  :showIcon="true"
                  :disabled="clickable"
                  @click="handleDeleteClick(row.data)"
                ></er-button>
              </el-row>
            </template>
          </er-data-tables>
        </er-card>
      </el-col>
    </el-row>

    <er-dialog
      :visible.sync="dialogVisible"
      width="25%"
      :close-on-click-modal="false"
      custom-class="pondFeed_dialog"
      :title="`${$t('Comn_update')} ${$t('Comn_manual_feed')}`"
    >
      <el-form
        size="small"
        :model="editManualFeedRec"
        :hide-required-asterisk="true"
      >
        <el-form-item
          :label="$t('Comn_pond_name')"
          prop="pond_id"
          :required="true"
        >
          <el-col :span="20">
            <er-select
              filterable
              size="small"
              v-model="editManualFeedRec.pond_id"
              value-key="_id"
              :disabled="true"
            >
              <el-option
                v-for="(pond, pond_id) in PondsObj"
                :key="pond_id"
                :value="pond_id"
                :label="pond.title"
              ></el-option>
            </er-select>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="$t('Comn_feed_name')"
          prop="feed_id"
          :required="true"
        >
          <el-col :span="20">
            <er-select
              size="small"
              filterable
              v-model="editManualFeedRec.feed_id"
              value-key="_id"
            >
              <el-option
                v-for="(rsc, rsc_id) in resourcesObj"
                :key="rsc_id"
                :value="rsc_id"
                :label="rsc.name"
              ></el-option>
            </er-select>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="$t('PM_dispensed_feed')"
          prop="feed_dispensed"
          :required="true"
        >
          <el-col :span="20">
            <el-input-number
              :controls="false"
              size="small"
              :min="0"
              :precision="2"
              v-model="editManualFeedRec.feed_dispensed"
            ></el-input-number>
          </el-col>
        </el-form-item>
      </el-form>

      <layout-toolbar slot="footer" justify="center">
        <er-button
          size="mini"
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          :loading="loading"
          @click="decideActionAndPrepPayload({}, 'save')"
          :disabled="isReadOnly"
        ></er-button>
        <er-button
          size="mini"
          btnType="cancel"
          :showLabel="true"
          @click="closeDialogBox"
          :disabled="isReadOnly"
        ></er-button>
      </layout-toolbar>
    </er-dialog>
  </el-row>
</template>

<script>
import filtersMixin from "@/mixins/filtersMixin.js";
import { mapActions, mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import printJS from "print-js";
import XLSX from "xlsx";
import notificationMixin from "@/mixins/notificationMixin";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  props: ["tabData"],
  mixins: [errorHandlerMixin, filtersMixin, notificationMixin],
  data: function() {
    return {
      data: [],
      dateRangeSelected: [],
      dialogVisible: false,
      loading: false,
      total_manual_feed: 0,
      highest_feed: 0,
      editManualFeedRec: {
        pond_id: "",
        feed_id: "",
        dispensed_feed: ""
      }
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      getPondIdPondMap: "getPondIdPondMap",
      pondId: "getSelectedPondId",
      getCurrentCulture: "getCurrentCulture",
      getRunningCultureForSelectedPond: "getRunningCultureForSelectedPond",
      getArrPrevCulturesForSelectedPond: "getArrPrevCulturesForSelectedPond"
    }),
    ...mapGetters("pond", {
      getAPondManualFeedRecords: "getAPondManualFeedRecords"
    }),
    ...mapGetters("user", {
      isReadOnly: "isReadOnly",
      getCurrUserLocation: "getCurrUserLocation",
      getUserCountryName: "getUserCountryName",
      getUserCountryCode: "getUserCountryCode"
    }),
    clickable() {
      return !this.isReadOnly && !this.getCurrentCulture.is_running;
    },
    location: function() {
      return this.$store.getters["user/getCurrUserLocation"];
    },
    PondsObj: function() {
      return this.getPondIdPondMap;
    },
    selectedPondDetails() {
      return this.PondsObj[this.pondId];
    },
    resourcesObj: function() {
      return this.$store.getters["resource/getObjResources"];
    },
    tableColumns: function() {
      return {
        doc: {
          prop: "doc",
          label: this.$t("Comn_doc"),
          ispdf: true,
          sortable: true,
          minWidth: 60
        },
        event_date: {
          prop: "date",
          label: this.$t("Medicines_event_date"),
          ispdf: true,
          sortable: true,
          minWidth: 100
        },
        feed_name: {
          prop: "feed_name",
          label: this.$t("Comn_feed_name"),
          ispdf: true,
          sortable: true,
          minWidth: 100
        },
        feed_dispensed: {
          prop: "feed_dispensed",
          label: this.$t("PM_dispensed_feed_kg"),
          ispdf: true,
          sortable: true,
          minWidth: 100
        },
        net_consumed: {
          prop: "net_consumed",
          label: this.$t("Comn_net_consumed_kg"),
          ispdf: true,
          sortable: true,
          minWidth: 100
        },
        actions: {
          label: this.$t("Comn_actions"),
          ispdf: false,
          minWidth: 80
        }
      };
    },
    groupByFeed: function() {
      return this.data.reduce((acc, curr) => {
        if (!curr) return acc;
        acc[curr.feed_name] =
          (acc[curr.feed_name] || 0) +
          (curr || { feed_dispensed: 0 }).feed_dispensed;
        return acc;
      }, {});
    },
    arrOfGroupedFeed: function() {
      return Object.keys(this.groupByFeed).sort(
        this.$commonUtils.alphaNumericComparator
      );
    },
    objOfPondManualFeedRec() {
      return this.getAPondManualFeedRecords.reduce((acc, curr) => {
        acc[curr._id] = curr;
        return acc;
      }, {});
    },
    pickerOptions: function() {
      return {
        disabledDate: date => {
          const start_date = this.$moment(
            this.getCurrentCulture.start_date
          ).valueOf();
          const end_date = this.$moment(
            this.getCurrentCulture.end_date
          ).valueOf();
          return !(date.getTime() >= start_date && date.getTime() <= end_date);
        }
      };
    }
  },
  async mounted() {
    this.initDate();
    await this.initComponent();
  },
  methods: {
    ...mapActions({
      fetchAllManualFeedingRecords: "pond/fetchAllManualFeedingRecords",
      fetchAllResources: "resource/fetchAllResources",
      fetchAPondManualFeedingRecords: "pond/fetchAPondManualFeedingRecords",
      deleteFeedRecord: "pond/deleteFeedRecord",
      saveManualFeedingRecords: "pond/saveManualFeedingRecords"
    }),
    handlePrintBtnClick: function() {
      printJS({
        printable: this.data.map(x => {
          x.date = this.$moment.utc(x.date).format("DD-MM-YYYY");
          return x;
        }),
        properties: Object.values(this.tableColumns)
          .filter(x => x.prop)
          .map(x => ({
            field: x.prop,
            displayName: x.label
          })),
        type: "json",
        documentTitle: `${this.selectedPondDetails.title} ${this.$t(
          "Comn_manual_feeding"
        )}`
      });
    },
    initDate() {
      this.dateRangeSelected = [
        this.$moment
          .utc(this.getCurrentCulture.start_date)
          .format("YYYY-MM-DD"),
        this.$moment.utc(this.getCurrentCulture.end_date).format("YYYY-MM-DD")
      ];
    },
    async initComponent() {
      try {
        this.loading = true;
        await Promise.all([
          this.fetchAllResources({
            type: "FEED",
            include_deleted: true,
            location_id: this.location._id
          }),
          this.fetchAPondManualFeedingRecords({
            pond_id: this.pondId,
            get_all: true,
            from_date: `${this.dateRangeSelected[0]}T00:00:00.000Z`,
            to_date: `${this.dateRangeSelected[1]}T00:00:00.000Z`
          })
        ]);
        const cultivation_date = `${this.dateRangeSelected[0]}T00:00:00.000Z`;
        this.data = this.getAPondManualFeedRecords
          .map(rec => {
            return rec.feeds.map(({ feed_dispensed, feed_id }, index) => {
              const doc =
                this.$moment
                  .utc(rec.date)
                  .diff(
                    this.$moment.utc(cultivation_date).startOf("days"),
                    "days"
                  ) + 1;
              const feed_name = feed_id.feed_type
                ? `${feed_id.name} - ${feed_id.feed_type}`
                : feed_id.name;
              return {
                feed_name: feed_name,
                feed_id: feed_id._id,
                feed_dispensed: feed_dispensed,
                date: rec.date,
                pond_id: rec.pond_id,
                doc: doc,
                feed_index: index,
                record_id: rec._id
              };
            });
          })
          .flat(1);
        this.data = this.data.sort((a, b) => a.doc - b.doc);
        let net_consumed = 0;
        this.data = this.data.map(x => {
          net_consumed += x.feed_dispensed;
          x.net_consumed = net_consumed;
          return x;
        });
        this.total_manual_feed = net_consumed;
        this.highest_feed = Math.max(
          ...this.data.map(x => x.feed_dispensed),
          0
        );
        this.data = this.data.sort(
          (a, b) => b.doc - a.doc || b.net_consumed - a.net_consumed
        );
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    handleEditMFeedRecord(editManualFeedRec) {
      try {
        this.isEditable(this.tabData);
        this.dialogVisible = true;
        this.editManualFeedRec = JSON.parse(JSON.stringify(editManualFeedRec));
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    async handleDeleteClick(rowData) {
      try {
        this.canUserDelete(this.tabData);
        await this.decideActionAndPrepPayload(rowData, "delete");
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    handleDownloadAction(downloadType) {
      try {
        this.isEditable(this.tabData);
        if (downloadType === "EXCEL") {
          this.exportAsExcel();
        } else if (downloadType === "PDF") {
          this.exportAsPDF();
        }
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    exportAsPDF() {
      const pdfcolumns = Object.values(this.tableColumns).reduce(function(
        accumulator,
        currentValue
      ) {
        if (currentValue.ispdf) {
          accumulator.push(currentValue.label);
        }
        return accumulator;
      },
      []);
      const data = this.data.map(
        ({ doc, date, feed_dispensed, feed_name, net_consumed }) => [
          doc,
          (date = this.$moment(date).format("YYYY-MM-DD")),
          feed_name,
          feed_dispensed,
          net_consumed
        ]
      );
      const docDefinition = {
        watermark: {
          text: "Eruvaka",
          color: "#d3d3d3",
          opacity: 0.3,
          bold: true,
          italics: false
        },

        content: [
          {
            text: [
              { text: this.dateRangeSelected[0] },
              { text: " - " },
              { text: this.dateRangeSelected[1] }
            ],
            style: "header"
          },

          {
            table: {
              body: [[...pdfcolumns], ...data]
            }
          }
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
            lineHeight: 1.5,
            alignment: "center",
            color: "red"
          }
        }
      };
      pdfMake.createPdf(docDefinition).download("Eruvaka");
    },
    exportAsExcel() {
      const xlData = this.data.map(
        ({ date, doc, feed_dispensed, feed_name, net_consumed }) => ({
          Date: this.$moment(date).format("YYYY-MM-DD"),
          "Day Of Culture": doc,
          "Feed Dispensed": feed_dispensed,
          "Feed Name": feed_name,
          "Net Consumed": net_consumed
        })
      );
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(xlData, {
        header: [
          "Date",
          "Day Of Culture",
          "Feed Name",
          "Feed Dispensed",
          "Net Consumed"
        ]
      });
      XLSX.utils.book_append_sheet(wb, ws, this.$t("Comn_manual_feed"));

      XLSX.writeFile(wb, "Manual Feed.xlsx", {
        type: "binary",
        cellDates: true
      });
    },
    closeDialogBox() {
      this.dialogVisible = false;
    },
    async decideActionAndPrepPayload(manualFeedRecord, action) {
      this.loading = true;
      const actionRecord =
        action === "save" ? this.editManualFeedRec : manualFeedRecord;
      const feedName = actionRecord.feed_name;
      const record = this.$lodash.cloneDeep(
        this.objOfPondManualFeedRec[actionRecord.record_id]
      );
      let recordFeedsArr = record.feeds;
      recordFeedsArr = recordFeedsArr.map(({ feed_dispensed, feed_id }) => {
        return {
          feed_dispensed,
          feed_id: feed_id._id
        };
      });
      if (action === "save") {
        record.feed_dispensed -=
          recordFeedsArr[actionRecord.feed_index].feed_dispensed;
        record.feed_dispensed += actionRecord.feed_dispensed;
        recordFeedsArr[actionRecord.feed_index].feed_dispensed =
          actionRecord.feed_dispensed;
        recordFeedsArr[actionRecord.feed_index].feed_id = actionRecord.feed_id;
        record.feeds = recordFeedsArr;
        await this.saveMEditedDetails(record, feedName);
      } else if (action === "delete") {
        if (recordFeedsArr.length > 1) {
          const recordToBeDel = recordFeedsArr[actionRecord.feed_index];
          record.feed_dispensed -= recordToBeDel.feed_dispensed;
          recordFeedsArr.splice(actionRecord.feed_index, 1);
          record.feeds = recordFeedsArr;
          await this.deleteMFeedRecord(record, feedName, "save");
        } else {
          await this.deleteMFeedRecord(record, feedName, "delete");
        }
      }
      this.loading = false;
    },
    async deleteMFeedRecord(record, feedName, action) {
      this.loading = true;
      try {
        await this.deleteConfirmation(feedName, this.selectedPondDetails.title);

        if (action === "save") {
          await this.saveManualFeedingRecords([record]);
        } else {
          await this.deleteFeedRecord(record._id);
        }
        this.$notify.success({
          title: this.$t("Usrs_success_msg"),
          message: `${feedName} ${this.$t("Comn_data_del_success")} ${
            this.selectedPondDetails.title
          }`
        });
        await this.initComponent();
      } catch (err) {
        if (err !== "cancel") {
          this.$notify.error({
            title: this.$t("failed"),
            message: this.$t("failed_to_complete_the_action_for_resource", {
              resource_name: feedName,
              action: this.$t("Comn_delete")
            })
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async saveMEditedDetails(payload, feedName) {
      try {
        await this.saveManualFeedingRecords([payload]);
        this.$notify.success({
          title: this.$t("Usrs_success_msg"),
          message: `${this.$t(
            "PM_feeding_data_succe_updated_for"
          )} ${feedName} `
        });
        this.dialogVisible = false;
        await this.initComponent();
      } catch (err) {
        this.$notify.error({
          title: this.$t("failed"),
          message: this.$t("failed_to_complete_the_action_for_resource", {
            resource_name: feedName,
            action: this.$t("Comn_update")
          })
        });
      }
    }
  }
};
</script>

<style lang="scss">
.pond-feed-tab {
  .second-label-container {
    display: flex;
    .total__feed__button {
      padding: 7px 15px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      background: #233a73;
      color: #ffffff;
      .total__feed__button__label {
        @include normal-text;
        padding-right: 10px;
      }
    }
    .highest__feed__button {
      padding: 7px 15px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      background-color: #f54e5e;
      color: #ffffff;
    }
    .highest__feed__button__value {
      @include normal-text;
    }
    .highest__feed__button__label {
      @include normal-text;
      padding-right: 10px;
    }
  }

  .el-date-editor .el-range__close-icon {
    display: none;
  }
  .date-picker.el-range-editor.el-date-editor.el-input,
  .date-picker.el-range-editor.el-date-editor.el-input__inner {
    @include responsiveProperty(width, 220px, 250px, 270px);
  }
  // .el-date-editor .el-range-separator {
  //   padding: 5px 0px;
  // }
  .date-picker.el-range-editor.el-input__inner {
    padding: 9px 10px;
  }

  // .el-range-editor--small .el-range-input {
  //   @include responsiveProperty(
  //     font-size,
  //     $app_font_size_1,
  //     $app_font_size_2,
  //     $app_font_size_3
  //   );
  // }
  .side-stats-content {
    // height: 15px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .el-select,
  .el-input-number {
    width: 100%;
  }
  //icons size
  .er-button.er-button--icon-text span > img,
  .er-button.er-button--icon-text span > span.material-icons-round,
  .er-button.er-button--icon-text span > span.material-icons-outlined {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
  }
  //date range
  // .el-range-editor--small .el-range__close-icon,
  // .el-range-editor--small .el-range__icon {
  //   line-height: 0px;
  // }
  // .el-range-editor--small.el-input__inner {
  //   @include responsiveProperty(height, 29px, 32px, 37px);
  // }

  // .el-range-editor--small .el-range-separator {
  //   @include responsiveProperty(line-height, 12px, 16px, 22px);
  //   @include responsiveProperty(
  //     font-size,
  //     $app_font_size_1,
  //     $app_font_size_2,
  //     $app_font_size_3
  //   );
  // }

  // .el-date-editor .el-range__icon {
  //   line-height: 0px;
  //   @include responsiveProperty(
  //     font-size,
  //     $app_font_size_1,
  //     $app_font_size_2,
  //     $app_font_size_3
  //   );
  //   display: contents;
  //   .el-input__icon {
  //     height: 0%;
  //   }
  //   .el-range-editor.el-input__inner {
  //     padding: 7px 15px;
  //   }
  // }
}
.pondFeed_dialog {
  background: #fcfcfc;
  border-radius: 10px;

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    .el-input-number {
      text-align: left;
    }
    @include responsiveProperty(width, 210px, 300px, 350px);
  }
}
</style>
